import React, { useEffect, useState } from 'react';
import { CWindowWidth } from 'constants/base.const';
import styled from 'styled-components';
import { device, SecondaryColor } from 'GlobalStyles';

const maxWidth = CWindowWidth - 200;

const SubNavBar = ({ contentsDom, notice }: any) => {
  const [contentHeight, setContentHeight] = useState({
    content1: 0,
    content2: 0,
    content3: 0,
    content4: 0,
    content5: 0,
    content6: 0,
  });
  const [nowHeight, setNowHeight] = useState<number>(0);
  const [checkPoint, setCheckPoint] = useState<number>(0);

  const moveScroll = (height: number) => {
    window.scrollTo({ top: height, left: 0, behavior: 'smooth' });
  };

  function getContentHeight() {
    const contentsLocation = {
      ...contentHeight,
      content1: contentsDom.current?.content1.getBoundingClientRect().top + window.pageYOffset - 350,
      content2: contentsDom.current?.content2.getBoundingClientRect().top + window.pageYOffset - 350,
      content3: contentsDom.current?.content3.getBoundingClientRect().top + window.pageYOffset - 350,
      content4: contentsDom.current?.content4.getBoundingClientRect().top + window.pageYOffset - 350,
      content5: contentsDom.current?.content5.getBoundingClientRect().top + window.pageYOffset - 350,
      content6: contentsDom.current?.content6.getBoundingClientRect().top + window.pageYOffset - 350,
    };

    setContentHeight((prev) => ({
      ...prev,
      ...contentsLocation,
    }));

    window.addEventListener('scroll', (e) => {
      setNowHeight(window.pageYOffset);
    });

    window.addEventListener('resize', (e) => {
      setNowHeight(window.pageYOffset);
    });
  }

  useEffect(() => {
    if (nowHeight < Math.floor(contentHeight.content1)) {
      setCheckPoint(0);
    }

    if (nowHeight >= Math.floor(contentHeight.content1) && nowHeight < Math.floor(contentHeight.content2)) {
      setCheckPoint(1);
    }

    if (nowHeight >= Math.floor(contentHeight.content2) && nowHeight < Math.floor(contentHeight.content3)) {
      setCheckPoint(2);
    }

    if (nowHeight >= Math.floor(contentHeight.content3) && nowHeight < Math.floor(contentHeight.content4)) {
      setCheckPoint(3);
    }

    if (nowHeight >= Math.floor(contentHeight.content4) && nowHeight < Math.floor(contentHeight.content5)) {
      setCheckPoint(4);
    }

    if (nowHeight >= Math.floor(contentHeight.content5) && nowHeight < Math.floor(contentHeight.content6)) {
      setCheckPoint(5);
    }

    if (nowHeight > Math.floor(contentHeight.content6)) {
      setCheckPoint(6);
    }

    getContentHeight();
  }, [nowHeight, notice]);

  const subNavBtnName = [
    { id: 1, name: 'Frameworks 듣고 보기', pos: contentHeight.content1 },
    { id: 2, name: '전략컨설팅 MasterClass [기초편]', pos: contentHeight.content2 },
    { id: 3, name: '케이스 문제 풀어보기', pos: contentHeight.content3 },
    { id: 4, name: '전략컨설팅 MasterClass [실습편]', pos: contentHeight.content4 },
    { id: 5, name: '케이스 노트 연습하기', pos: contentHeight.content5 },
    { id: 6, name: '실전 Mock 인터뷰', pos: contentHeight.content6 },
  ];

  return (
    <StyledContainer>
      <SubNavBtns>
        {subNavBtnName.map(({ id, name, pos }) => (
          <SubNavBtn contentNum={id} checkPoint={checkPoint} onClick={() => moveScroll(pos)} key={id}>
            {name}
          </SubNavBtn>
        ))}
      </SubNavBtns>
    </StyledContainer>
  );
};

export default SubNavBar;

type TSubNavBtn = {
  checkPoint: any;
  contentNum: number;
};

const StyledContainer = styled.nav`
  position: sticky;
  top: 100px;
  z-index: 9;
  background-color: #f9f9f9;
  padding: 17px 0;

  @media screen and ${device.lg} {
    display: none;
  }
`;

const SubNavBtns = styled.ul`
  display: flex;
  align-items: center;
  max-width: ${maxWidth}px;
  margin: 0 auto;
  padding: 0;
  color: ${SecondaryColor};
`;

const SubNavBtn = styled.li<TSubNavBtn>`
  flex: 1;
  padding: 16px 0;
  text-align: center;
  border: 1px solid #e4e4e4;
  background-color: ${({ checkPoint, contentNum }) =>
    checkPoint === contentNum ? SecondaryColor : '#ffffff'};
  color: ${({ checkPoint, contentNum }) => (checkPoint === contentNum ? '#ffffff' : SecondaryColor)};
  cursor: pointer;
  list-style: none;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${SecondaryColor};
    color: #ffffff;
  }
`;
